<template>
  <div class="home">
    <div class="home-logo">
      <img src="/logo.png" alt="LOGO">
    </div>

    <article class="sales-process">
      <h1><strong>Proces de Vânzare & Contractare – Darleot Group</strong></h1>
      <p>
        Această procedură descrie pașii oficiali ai procesului de vânzare și contractare,
        folosind exclusiv funcționalitățile existente în CRM-ul Darleot Group.
        Scopul este să existe o trasabilitate clară a fiecărui client, ofertă, comandă,
        contract și factură, accesibilă pentru toți angajații.
      </p>

      <h2><strong>1. Înregistrarea clientului</strong></h2>
      <ul>
        <li>Accesează <strong>CRM → Clienți → Adaugă Client</strong>.</li>
        <li>Completează toate câmpurile de identificare (date firmă/persoană, adresă, contact, email, telefon).</li>
        <li>Încarcă documentele primite (cereri, acte, corespondență) în secțiunea <strong>Documente</strong>.</li>
        <li>Folosește câmpul <strong>Notițe</strong> pentru informații relevante din discuțiile inițiale.</li>
      </ul>

      <h2><strong>2. Preluarea cererilor de ofertă</strong></h2>
      <p>
        Toate solicitările primite sunt înregistrate automat în
        <strong>Oferte → Cerere ofertă</strong>. Angajatul responsabil verifică cererile
        și decide dacă se creează o ofertă nouă în CRM. Informațiile suplimentare
        se pot adăuga în secțiunea <strong>Notițe</strong> a clientului.
      </p>

      <h2><strong>3. Crearea unei oferte</strong></h2>
      <ul>
        <li>Mergi la <strong>Oferte → Creează Ofertă</strong>.</li>
        <li>Selectează clientul din listă sau adaugă unul nou.</li>
        <li>Adaugă produsele și cantitățile (din lista de <strong>Produse</strong>).</li>
        <li>Completează condițiile comerciale (<strong>discount</strong>, <strong>adaos</strong>).</li>
        <li>Previzualizează și salvează oferta; poți:
          <ul>
            <li><strong>Descarcă ofertă (PDF)</strong>,</li>
            <li><strong>Salvează ofertă</strong>,</li>
            <li><strong>Trimite ofertă</strong> direct din CRM.</li>
          </ul>
        </li>
      </ul>

      <h2><strong>4. Folosirea șabloanelor de ofertă</strong></h2>
      <p>
        Pentru a standardiza conținutul, mergi la <strong>Oferte → Șabloane ofertă</strong>.  
        Poți adăuga sau selecta un șablon predefinit (ex. General, BAU etc.).  
        La generarea unei oferte, poți alege un șablon pentru a uniformiza prezentarea și a reduce timpul de lucru.  
        Șabloanele pot fi <strong>vizualizate</strong>, <strong>editate</strong> sau <strong>șterse</strong> în funcție de necesități.
      </p>

      <h2><strong>5. Negocierea ofertei</strong></h2>
      <p>
        Discuțiile cu clientul și modificările cerute se notează în <strong>Notițe</strong>
        la nivel de ofertă sau client. Dacă se face o revizuire, se <strong>editează</strong>
        sau se creează o ofertă nouă pe baza celei existente.
      </p>

      <h2><strong>6. Generarea comenzii</strong></h2>
      <p>
        După acceptarea unei oferte, mergi la <strong>Comenzi → Adaugă Comandă</strong>.  
        Selectează clientul și adaugă produsele/serviciile convenite.  
        Salvează comanda în CRM.
      </p>

      <h2><strong>7. Contractarea</strong></h2>
      <p>
        Contractul comercial se redactează pe baza comenzii aprobate.  
        Documentul semnat (PDF/Word) se încarcă în CRM la fișa clientului sau comenzii.  
        Orice anexe sau acte adiționale se atașează în aceeași secțiune <strong>Documente</strong>.
      </p>

      <h2><strong>8. Facturarea</strong></h2>
      <p>
        Accesează <strong>Facturi → Adaugă Factură</strong>.  
        Selectează clientul și preia datele din comandă.  
        Adaugă produsele/serviciile și setează data scadenței.  
        Salvează și emite factura (PDF descărcabil sau transmis direct).  
        Eventualele dovezi de plată se încarcă la secțiunea <strong>Documente</strong>.
      </p>

      <h2><strong>9. Reguli generale</strong></h2>
      <ul>
        <li>Documentele (oferte, șabloane, contracte, facturi) se salvează/încarcă în CRM pentru arhivare.</li>
        <li>Orice discuție comercială importantă se notează în <strong>Notițe</strong>.</li>
        <li>Astfel, orice angajat nou poate urmări întregul istoric și continua procesul fără întreruperi.</li>
      </ul>

      <h2><strong>👉 Această pagină este referința oficială</strong></h2>
      <p>
        pentru procesul de vânzare și contractare Darleot Group și este
        <strong>obligatoriu</strong> pentru toți utilizatorii CRM.
      </p>
    </article>
    <!-- ===== Sfârșit pagină ===== -->
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      datacollection: null,
      chartData: null
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
  }
}
</script>

<style scoped>
.home {
  padding: 20px;
}

.home-logo {
  text-align: center;
  margin-bottom: 20px;
}

.sales-process {
  padding: 20px;
  line-height: 1.6;
  background: #fff;
}

.sales-process h1,
.sales-process h2 {
  margin-top: 1.5rem;
}

.sales-process ul {
  padding-left: 1.2rem;
}
</style>